const setGraphData_leftsell = payload => {
  return {
    type: "setGraphData_leftsell",
    payload
  };
};
export default setGraphData_leftsell;
